/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxGamesLibWebPlatformDataOptionsPlatformDataOptionsFxId
 */
export interface FxGamesLibWebPlatformDataOptionsPlatformDataOptionsFxId {
    /**
     * 
     * @type {string}
     * @memberof FxGamesLibWebPlatformDataOptionsPlatformDataOptionsFxId
     */
    GameSystemName: string;
}

/**
 * Check if a given object implements the FxGamesLibWebPlatformDataOptionsPlatformDataOptionsFxId interface.
 */
export function instanceOfFxGamesLibWebPlatformDataOptionsPlatformDataOptionsFxId(value: object): value is FxGamesLibWebPlatformDataOptionsPlatformDataOptionsFxId {
    if (!('GameSystemName' in value) || value['GameSystemName'] === undefined) return false;
    return true;
}

export function FxGamesLibWebPlatformDataOptionsPlatformDataOptionsFxIdFromJSON(json: any): FxGamesLibWebPlatformDataOptionsPlatformDataOptionsFxId {
    return FxGamesLibWebPlatformDataOptionsPlatformDataOptionsFxIdFromJSONTyped(json, false);
}

export function FxGamesLibWebPlatformDataOptionsPlatformDataOptionsFxIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxGamesLibWebPlatformDataOptionsPlatformDataOptionsFxId {
    if (json == null) {
        return json;
    }
    return {
        
        'GameSystemName': json['GameSystemName'],
    };
}

export function FxGamesLibWebPlatformDataOptionsPlatformDataOptionsFxIdToJSON(json: any): FxGamesLibWebPlatformDataOptionsPlatformDataOptionsFxId {
    return FxGamesLibWebPlatformDataOptionsPlatformDataOptionsFxIdToJSONTyped(json, false);
}

export function FxGamesLibWebPlatformDataOptionsPlatformDataOptionsFxIdToJSONTyped(value?: FxGamesLibWebPlatformDataOptionsPlatformDataOptionsFxId | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'GameSystemName': value['GameSystemName'],
    };
}

